import HomeIcon from '@mui/icons-material/Home'
import AccountTreeIcon from '@mui/icons-material/AccountTree'
import HistoryIcon from '@mui/icons-material/History'
import MoreVertIcon from '@mui/icons-material/MoreVert'

const sx = { fontSize: 24, color: '#fff' }
const config = () => [
  {
    section: '#Landing',
    tooltip: 'Landing',
    icon: <HomeIcon sx={sx} />,
  },
  {
    section: '#Projects',
    tooltip: 'Projects',
    icon: <AccountTreeIcon sx={sx} />,
  },
  {
    section: '#Blogs',
    tooltip: 'Blogs',
    icon: <HistoryIcon sx={sx} />,
  },
  {
    section: '#Contact',
    tooltip: 'Contact',
    icon: <MoreVertIcon sx={sx} />,
  },
]

export default config
